export default "__VITE_ASSET__275dd6aa__"